module.exports = __webpack_public_path__ + "static/media/company-address.409ba962.png";